<template>
  <div style="content-visibility: hidden;" v-if="showCompareContent">
    <div id="outer-wrapper" class="container-fluid">
      <div class="row">
        <div
          class="col-md-3"
          v-for="item in getCompareProducts"
          :key="item.styleNumber"
        >
          <div>
            <div class="compare-div-part mb-2">
              <div class="pop-up-compare-div-image mb-3">
                <img
                  @error="handleImageError"
                  :alt="item.colors[0].colorNumber"
                  :src="
                    item.colors[0].imagePath != 'null' && item.colors[0].imagePath != null
                    ?
                    item.colors[0].imagePath.includes('?') ? item.colors[0].imagePath + '&' : item.colors[0].imagePath + '?'
                    :
                    ''
                  "
                  crossOrigin="anonymous"
                  class="w-100"
                />
              </div>
              <dl class="description text-uppercase">
                <div>
                  <dt>
                    <u>{{ item.colors[0].colorName }}</u>
                  </dt>
                  <dd>
                    {{ item.colors[0].colorNumber }}
                  </dd>
                </div>
                <div>
                  <dt>
                    {{
                      $resourceString[
                        "product.details.specifications.product.style"
                      ]
                    }}
                  </dt>
                  <dd>
                    {{ item.sellingStyleName }}
                  </dd>
                </div>
                <div>
                  <dt>
                    {{
                      $resourceString[
                        "product.details.specifications.product.collection"
                      ]
                    }}
                  </dt>
                  <dd>
                    {{ item.collection }}
                  </dd>
                </div>
                <div class="swatches-part">
                  <p class="swatch-title text-uppercase">
                    <b>{{ item.colors.length }}</b>
                    {{
                      $resourceString[
                        "product.details.room.scene.swatch.colors"
                      ]
                    }}
                  </p>
                  <div class="row">
                    <div
                      class="col-4"
                      v-for="color in item.colors"
                      :key="color.colorName + color.colorNumber"
                    >
                      <img crossOrigin="anonymous"  @error="handleImageError" :src="
                        color.imagePath != 'null' && color.imagePath != null
                        ?
                        color.imagePath.includes('?') ? color.imagePath + '&' : color.imagePath + '?'
                        :
                        ''
                      " class="w-100" alt="" />
                      <div class="wf-product-room-scene-color-item-name">
                        {{ color.colorName }}<br />
                        {{ color.colorNumber }}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="specification-part">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.specifications"
                        ]
                      }}
                    </h3>
                    <div class="">
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.product.category"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.inventorySubType }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.product.category"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.inventorySubType }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.product.type"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.inventoryType }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.secondary.backing"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.secondaryBacking }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.construction"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.construction }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.wear.rating"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.testResults.tarrClassification }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.dye.method"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.dyeMethod }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.fiber"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.fiber }}
                      </dd>
                    </div>
                    <div v-if="item.areaPerCarton">
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.squareyards"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{
                          Math.round(
                            item.areaPerCarton.metric.formattedValue * 100
                          ) / 100
                        }}
                      </dd>
                    </div>
                  </div>
                  <div class="pdq-part">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.pdq.details"
                        ]
                      }}
                    </h3>
                    <dt
                      class="pdq-name text-uppercase"
                      v-html="item.pdqDetails"
                    ></dt>
                  </div>
                  <div class="sustain-part mb-3">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.sustainability"
                        ]
                      }}
                    </h3>
                    <dt>
                      {{
                        $resourceString[
                          "product.details.specifications.recyclability"
                        ]
                      }}
                    </dt>
                    <dd>
                      {{ item.recyclability }}
                    </dd>
                  </div>
                  <div class="third-party-part">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.third.party.certificates"
                        ]
                      }}
                    </h3>

                    <div
                      class="third-party-items mb-2"
                      v-if="item.attributes.length > 0"
                      v-for="attribute in item.attributes"
                      :key="attribute.name"
                    >
                      <dt v-if="attribute.pdfLink">
                        {{ attribute.name }}
                      </dt>
                      <dd v-if="attribute.pdfLink">
                        <u>
                          {{ attribute.status }}
                        </u>
                      </dd>
                    </div>
                    <div
                      class="third-party-items mb-2"
                      v-if="item.certifications.length > 0"
                      v-for="certification in item.certifications"
                      :key="certification.name"
                    >
                      <dt v-if="certification.pdfLink">
                        {{ certification.name }}
                      </dt>
                      <dd v-if="certification.pdfLink">
                        <u>
                          {{ certification.status }}
                        </u>
                      </dd>
                    </div>

                  </div>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { globalIcons } from "../../../constants/global";
export default {
  data(){
    return{
      defaultImage:globalIcons.defaultImage,
    }
  },
  computed: {
    ...mapGetters({
      getCompareProducts: "productDetail/getCompareProducts",
      showCompareContent: "compareModal/showCompareContent"
    })
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
  }
};
</script>
